<template>
  <div class="container">
    <h1>Fichiers - Anglais</h1>

    <div class="row">
      <div class="col-md-3">
        <b-card bg-variant="light">
          <b-card-title class="h5 mb-0 font-weight-normal"
            >Contenu</b-card-title
          >
          <b-card-text class="small text-muted">Dernière version</b-card-text>
          <b-card-text class="font-weight-bold lead text-info">{{
            latestVersions.data ? latestVersions.data.version : 'Inconnu'
          }}</b-card-text>
        </b-card>
      </div>
    </div>

    <b-alert variant="warning" show class="mt-4">
      <p class="m-0">
        Lorsqu'une salle met à jour son contenu, l'ordre d'importation est le
        suivant:
        <span class="font-weight-bold">Jeu > Question > DMX > Médias</span>.
      </p>
    </b-alert>

    <hr />

    <div class="my-2 d-flex justify-content-between">
      <p></p>
      <div class="inline-block">
        <b-button size="sm" variant="primary" class="ml-1" v-b-modal.add-file
          >Ajouter un nouveau fichier</b-button
        >
      </div>
    </div>

    <div
      v-if="list.length == 0"
      class="d-flex justify-content-center align-items-center p-5 bg-light"
    >
      Aucun élément.
    </div>
    <b-table
      v-else
      striped
      hover
      primary-key="id"
      :fields="fields"
      :items="list"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <template #cell(id)="data">
        <span v-b-tooltip.hover :title="data.item.filename">
          {{ '...' + data.value.slice(-8) }}
        </span>
      </template>

      <template #cell(description)="data">
        <b-badge
          v-if="data.value"
          variant="light"
          v-b-popover.hover.top="data.value"
          :title="data.item.version"
          class="text-truncate mt-1"
          style="max-width: 200px"
        >
          {{ data.value }}
        </b-badge>
      </template>

      <template #cell(options)="data">
        <b-popover
          v-if="data.value"
          :target="`popover_options__${data.item._id}`"
          placement="top"
          triggers="hover focus"
        >
          <template #title>
            <span class="font-weight-bold">Options</span>
          </template>
          <div class="d-flex flex-column">
            <div class="d-flex justify-content-between">
              <div class="mr-2">Supprimer les questions:</div>
              <div v-if="data.value.removeCustomQuestions">
                {{ data.value.removeCustomQuestions.length }} questions
              </div>
              <div v-else>Aucune</div>
            </div>
          </div>
        </b-popover>

        <b-badge
          v-if="data.value"
          variant="success"
          :id="`popover_options__${data.item._id}`"
          class="text-truncate mt-1"
          style="max-width: 200px"
        >
          Oui
        </b-badge>
        <b-badge
          v-else
          variant="light"
          :id="`popover_options__${data.item._id}`"
          class="text-truncate mt-1"
          style="max-width: 200px"
        >
          Non
        </b-badge>
      </template>

      <template #cell(type)="data">
        <b-badge v-if="data.value == 'package'" variant="info">{{
          capitalize(data.value)
        }}</b-badge>
        <b-badge v-else variant="success">{{ capitalize(data.value) }}</b-badge>
      </template>

      <template #cell(language)="data">
        <span>{{ languagesSelect[data.value] || data.value || '' }}</span>
      </template>

      <template #cell(preRelease)="data">
        <b-badge v-if="data.value == true" variant="warning"
          >Pré Release</b-badge
        >
        <b-badge v-else variant="light">Stable</b-badge>
      </template>

      <template #cell(enabled)="data">
        <b-badge v-if="data.value == true" variant="success">Oui</b-badge>
        <b-badge v-else variant="light">Non</b-badge>
      </template>

      <template #cell(createdAt)="data">
        {{ data.value | formatDate }}
      </template>

      <template #cell(actions)="data">
        <div class="d-flex justify-content-end">
          <!-- <b-button v-if="data.item.enabled == true" size="sm" variant="warning" @click="disableVersion(data.item)">Désactiver</b-button>
            <b-button v-else type="button" size="sm" variant="success" @click="enableVersion(data.item)">Activer</b-button> -->
          <b-button
            size="sm"
            variant="danger"
            class="ml-1"
            @click="destroyVersion(data.item)"
            >Supprimer</b-button
          >
          <b-button
            size="sm"
            variant="primary"
            class="mx-1"
            @click="showContent(data.item)"
            >Voir le contenu</b-button
          >
          <b-button
            size="sm"
            variant="info"
            class="ml-1"
            @click="downloadVersion(data.item)"
            >Télécharger</b-button
          >
        </div>
      </template>
    </b-table>

    <div class="d-inline-block d-sm-flex justify-content-between mt-3">
      <b-pagination
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
      ></b-pagination>

      <b-form-group
        class=""
        label="Par page"
        label-cols-sm="6"
        label-cols-lg="6"
        content-cols-sm="6"
        content-cols-lg="6"
      >
        <b-form-select v-model="perPage" class="ml-2">
          <option value="10">10</option>
          <option value="25">25</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </b-form-select>
      </b-form-group>
    </div>

    <b-modal
      id="add-file"
      title="Ajouter un nouveau fichier"
      :hide-footer="true"
      ref="add-file-modal"
    >
      <div class="mb-5">
        <p class="bg-light p-2">
          Ajouter un nouveau fichier ZIP contenant les fichiers à ajouter et/ou
          à remplacer.
        </p>
        <b-alert
          :show="newFileWarningMessage !== null"
          variant="warning"
          dismissible
          @dismissed="newFileWarningMessage = null"
        >
          <p class="small m-0">{{ newFileWarningMessage }}</p>
        </b-alert>
        <b-alert :show="newFileErrorMessage !== null" variant="danger">
          <p class="small m-0" v-html="newFileErrorMessage" />
        </b-alert>
        <b-alert :show="newFileFormReady === true" variant="success">
          <p class="small m-0">
            Tout semble conforme, vous pouvez maintenant envoyer le fichier.
          </p>
        </b-alert>

        <b-alert show variant="info">
          <div class="small m-0">
            Le fichier ZIP <strong>PEUT</strong> contenir:
            <ul class="m-0 mb-2">
              <li>
                Un fichier <strong>encodé</strong> nommé
                <code>questions.txt</code> à la racine
              </li>
              <li>Un fichier nommé <code>questions.xlsx</code> à la racine</li>
              <li>
                Un fichier <strong>encodé</strong> nommé
                <code>games.txt</code> à la racine
              </li>
              <li>
                Un fichier nommé <code>dmx.txt</code> à la racine
                <i>(coming soon)</i>
              </li>
            </ul>
            <ul class="m-0">
              <li>Un dossier <code>assets/images</code></li>
              <li>Un dossier <code>assets/videos</code></li>
              <li>Un dossier <code>assets/sounds</code></li>
              <li>Un dossier <code>uploads/images</code></li>
              <li>Un dossier <code>uploads/videos</code></li>
              <li>Un dossier <code>uploads/sounds</code></li>
            </ul>
          </div>
          <div class="small mt-3">
            Si vous ajoutez un fichier <code>questions.txt</code> ou
            <code>questions.xslx</code>,
            <strong
              >les anciennes questions par défaut seront supprimées</strong
            >
            avant d'ajouter les nouvelles.
          </div>
        </b-alert>
      </div>

      <div v-if="uploadingPercent !== null" class="mb-4">
        <h5>Progression de l'envoi</h5>
        <b-progress
          :value="uploadingPercent"
          :max="100"
          :label="`${uploadingPercent}%`"
          variant="info"
          show-progress
          animated
        ></b-progress>
      </div>

      <b-form @submit.prevent="submitNewFile">
        <b-form-group
          label="Fichier ZIP:"
          description="Sélectionnez le fichier ZIP avec le nouveau contenu. Les champs suivants seront automatiquement pré-remplis si le nom du fichier contient le type et la version (exemple: question-2.0.0.zip)"
        >
          <b-form-file
            v-model="newFileForm.file"
            accept=".zip"
            placeholder="Choisissez un fichier"
            drop-placeholder="Déposez un fichier ici..."
            @change="newFileChanged"
          ></b-form-file>
        </b-form-group>

        <b-form-group
          label="Version:"
          description="Il doit être au format X.Y.Z ou X.Y.Z-A. Exemple: 2.3.0 ou 3.1.2-18"
        >
          <b-form-input
            v-model="newFileForm.version"
            placeholder="Numéro de version"
            @change="resetNewFileErrors"
          ></b-form-input>
        </b-form-group>

        <b-form-group label="Description:">
          <b-form-textarea
            v-model="newFileForm.description"
            @change="resetNewFileErrors"
          ></b-form-textarea>
        </b-form-group>

        <hr />

        <b-form-group
          label="Supprimer les questions:"
          description="Saisissez les identifiants des questions que vous voulez supprimer. Un identifiant par ligne. Optionnel"
        >
          <b-form-textarea
            v-model="newFileForm.options.removeCustomQuestions"
            @change="resetNewFileErrors"
          ></b-form-textarea>
        </b-form-group>

        <div class="d-flex justify-content-between mt-5">
          <b-button
            type="button"
            variant="light"
            :disabled="isUploading"
            @click="cancelAddFile"
            >Annuler</b-button
          >
          <b-button
            v-if="newFileFormReady !== true"
            type="button"
            variant="primary"
            :disabled="isUploading"
            @click="verifyVersion"
            >Vérifier la version</b-button
          >
          <b-button
            v-else
            type="submit"
            variant="success"
            :disabled="isUploading"
            >Envoyer</b-button
          >
        </div>
      </b-form>
    </b-modal>

    <b-modal
      id="zip-content-modal"
      title="Contenu du ZIP"
      :hide-footer="true"
      ref="zip-content-modal"
    >
      <b-spinner
        v-if="zipContentLoading"
        variant="primary"
        label="Spinning"
      ></b-spinner>
      <ul>
        <li v-for="file in zipContent" :key="file">{{ file }}</li>
      </ul>
    </b-modal>
  </div>
</template>

<script>
  import axios from 'axios'
  import { capitalize, invert } from 'lodash'

  export default {
    name: 'FilesEnglish',
    props: [],
    data() {
      return {
        fileImages: null,
        fileSounds: null,
        fileVideos: null,
        fileGames: null,

        latestVersions: {
          package: null,
          data: null,
        },

        type: 'data',
        language: 'en',
        types: [],
        list: [],
        currentPage: 1,
        perPage: 10,

        newFileForm: {
          type: 'data',
          version: null,
          language: 'en',
          file: null,
          description: null,
          options: {
            removeCustomQuestions: '',
          },
        },
        newFileFormReady: false,
        uploadingPercent: null,
        newFileWarningMessage: null,
        newFileErrorMessage: null,

        zipContentLoading: false,
        zipContentLoadingError: null,
        zipContent: null,
      }
    },
    computed: {
      fields() {
        return [
          {
            key: 'id',
            label: '#',
            sortable: false,
            sortDirection: 'asc',
            tdClass: 'text-center font-weight-bold',
          },
          // {
          //     key: 'filename',
          //     label: 'Fichier',
          //     sortable: false,
          //     thClass: 'text-center',
          //     tdClass: 'text-center',
          // },
          // {
          //   key: 'type',
          //   label: 'Type',
          //   sortable: false,
          //   thClass: 'text-center',
          //   tdClass: 'text-center',
          // },
          // {
          //   key: 'language',
          //   label: 'Langue',
          //   sortable: true,
          //   thClass: 'text-center',
          //   tdClass: 'text-center',
          // },
          {
            key: 'version',
            label: 'Version',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'description',
            label: 'Description',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'options',
            label: 'Options',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'preRelease',
            label: 'Pré Release',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'createdAt',
            label: 'Créé le',
            sortable: false,
            thClass: 'text-center',
            tdClass: 'text-center',
          },
          {
            key: 'actions',
            label: '',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ]
      },
      totalRows() {
        return this.list.length
      },
      isUploading() {
        return this.uploadingPercent !== null
      },
      removeCustomQuestionsList() {
        return this.newFileForm.options.removeCustomQuestions
          .split('\n')
          .map((id) => id.trim())
          .filter((id) => id !== '')
      },
      languages() {
        return {
          null: '',
          all: 'Dans toutes les langues uniquement',
          fr: 'Français',
          en: 'Anglais',
        }
      },
      languagesSelect() {
        return {
          all: 'Toutes',
          fr: 'Français',
          en: 'Anglais',
        }
      },
    },
    mounted() {
      this.fetchAnalytics()
      this.fetchVersionsTypes()
      this.fetchVersions()
    },
    methods: {
      getOptionsPopoverContent(options) {
        return `
        <div class="d-flex flex-column">
          <div class="d-flex justify-content-between">
            <div>Supprimer les questions:</div>
            <div>${options.removeCustomQuestions}</div>
          </div>
        </div>
        `
      },
      fetchVersionsTypes() {
        axios
          .get('/version/types')
          .then((response) => {
            // this.types = invert(response.data).filter((type) => type !== 'package');
            this.types = invert(response.data)
          })
          .catch((error) => {
            console.log(error)
          })
      },
      fetchVersions() {
        axios
          .get('/version', {
            params: {
              type: this.type,
              language: this.language,
            },
          })
          .then((response) => {
            this.list = response.data
          })
          .catch((error) => {
            console.log(error)
          })
      },
      fetchAnalytics() {
        axios
          .get('/version/analytics', {
            params: {
              type: this.type,
              language: this.language,
            },
          })
          .then((response) => {
            Object.keys(this.latestVersions).forEach((type) => {
              console.log(type, response.data[type])
              if (response.data[type] && response.data[type].latest) {
                this.latestVersions[type] = response.data[type].latest
              } else {
                this.latestVersions[type] = null
              }
            })
          })
          .catch((error) => {
            console.log(error)
          })
      },
      verifyVersion() {
        const validated = this.validateNewFileForm()
        if (!validated) {
          return
        }

        axios
          .get('/version/available', {
            params: {
              type: this.newFileForm.type,
              version: this.newFileForm.version,
            },
          })
          .then((response) => {
            this.newFileFormReady = response.data.available
            if (!response.data.available) {
              this.newFileWarningMessage = 'Cette version existe déjà.'
            }
          })
          .catch((error) => {
            this.newFileErrorMessage = error.response.data.message
          })
      },
      downloadVersion(version) {
        this.$notify({
          type: 'info',
          title: 'Téléchargement en cours...',
        })

        let url =
          process.env.NODE_ENV === 'development' ? 'http://localhost:8090' : ''
        url += `/api/version/download/${version.id}`

        // Download the file via the browser
        window.open(url, '_self')
      },
      async showContent(version) {
        this.zipContentLoading = true
        this.zipContentLoadingError = null
        this.zipContent = null

        this.$refs['zip-content-modal'].show()

        try {
          const response = await axios.get(
            '/api/version/' + version.id + '/content'
          )
          this.zipContent = response.data
        } catch (error) {
          this.zipContentLoadingError = error.response.data.message
        } finally {
          this.zipContentLoading = false
        }
      },
      destroyVersion(version) {
        if (
          !confirm(
            'Êtes-vous sûr de vouloir supprimer la version "' +
              version.type +
              ' v' +
              version.version +
              '" ?'
          )
        ) {
          return
        }

        axios
          .delete('/version/' + version.id)
          .then(() => {
            this.$notify({
              type: 'success',
              title: 'Suppression réussie',
            })

            this.fetchVersions()
            this.fetchAnalytics()
          })
          .catch((error) => {
            console.log(error)

            let errorMessage = 'Erreur inconnue.'
            if (error.response) {
              errorMessage = error.response.data.message
            }

            this.$notify({
              type: 'error',
              title: 'Erreur de suppression',
              text: errorMessage,
            })
          })
      },
      capitalize(string) {
        return capitalize(string)
      },
      cancelAddFile() {
        this.$refs['add-file-modal'].hide()
        this.clearNewFileForm()
        this.resetNewFileErrors()
      },
      clearNewFileForm() {
        this.newFileForm = {
          type: 'data',
          version: null,
          language: 'all',
          file: null,
          description: null,
          options: {
            removeCustomQuestions: '',
          },
        }

        this.newFileFormReady = false
      },
      resetNewFileErrors() {
        this.newFileWarningMessage = null
        this.newFileErrorMessage = null
      },
      typeChanged() {
        this.resetNewFileErrors()

        if (this.newFileForm.type !== 'question') {
          this.newFileForm.options.removeCustomQuestions = ''
        }
      },
      newFileChanged(event) {
        this.resetNewFileErrors()

        // On tente de deviner le type et la version du fichier, à partir de son nom
        const filename = event.target.files[0].name
        const filenameWithoutExtension = filename
          .split('.')
          .slice(0, -1)
          .join('.')

        let splitterPattern

        if (
          filenameWithoutExtension.includes('-') &&
          filenameWithoutExtension.split('-').length === 2
        ) {
          splitterPattern = '-'
        } else if (
          filenameWithoutExtension.includes('-v') &&
          filenameWithoutExtension.split('-v').length === 2
        ) {
          splitterPattern = '-v'
        } else if (
          filenameWithoutExtension.includes('_') &&
          filenameWithoutExtension.split('_').length === 2
        ) {
          splitterPattern = '_'
        } else if (
          filenameWithoutExtension.includes('_v') &&
          filenameWithoutExtension.split('_v').length === 2
        ) {
          splitterPattern = '_v'
        }

        if (splitterPattern) {
          // eslint-disable-next-line no-unused-vars
          const [type, version] =
            filenameWithoutExtension.split(splitterPattern)

          this.newFileForm.version = version
        } else {
          console.log('here')
          this.newFileWarningMessage =
            'Impossible de déterminer la version du fichier. Veuillez les renseigner manuellement.'
          console.log(this.newFileWarningMessage)
        }
      },
      validateNewFileForm() {
        this.resetNewFileErrors()

        if (!this.newFileForm.file) {
          this.newFileErrorMessage = 'Veuillez sélectionner un fichier.'
          return false
        }
        if (!this.newFileForm.type) {
          this.newFileErrorMessage = 'Veuillez renseigner le type du fichier.'
          return false
        }
        if (!this.newFileForm.version) {
          this.newFileErrorMessage =
            'Veuillez renseigner la version du fichier.'
          return false
        }
        if (!this.newFileForm.language) {
          this.newFileErrorMessage = 'Veuillez renseigner la langue du fichier.'
          return false
        }
        if (
          this.newFileForm.version.match(/^(\d+\.)?(\d+\.)?(\*|\d+)$/) === null
        ) {
          this.newFileErrorMessage =
            'La version du fichier doit correspondre au format "X.Y.Z" ou "X.Y.Z-A".'
          return false
        }

        return true
      },
      submitNewFile() {
        const validated = this.validateNewFileForm()
        if (!validated) {
          return
        }

        this.uploadingPercent = 0

        // FormData
        const formdata = new FormData()
        formdata.append('file', this.newFileForm.file)
        formdata.append('type', this.newFileForm.type)
        formdata.append('version', this.newFileForm.version)
        formdata.append('language', this.newFileForm.language)
        formdata.append('preRelease', this.newFileForm.version.includes('-'))
        formdata.append('description', this.newFileForm.description || '')
        for (const key in this.removeCustomQuestionsList) {
          formdata.append(
            'options[removeCustomQuestions][]',
            this.removeCustomQuestionsList[key]
          )
        }

        // Axios
        const config = {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded / progressEvent.total) * 100
            )
            this.uploadingPercent = percentCompleted
          },
        }

        axios
          .post('/version', formdata, config)
          .then((response) => {
            console.log('success!', response)

            this.$notify({
              type: 'success',
              title: 'Fichier ajouté',
              text: 'Le fichier a bien été ajouté.',
            })

            this.$refs['add-file-modal'].hide()
            this.clearNewFileForm()
            this.resetNewFileErrors()
            this.fetchVersions()
            this.fetchAnalytics()
          })
          .catch((error) => {
            console.log(error, error.response)

            if (error.response && error.response.status === 422) {
              const fieldErrors = error.response.data.errors
              const errors = fieldErrors
                .map((field) => '- ' + field.msg)
                .join('<br>')
              this.newFileErrorMessage = errors
            } else {
              this.newFileErrorMessage =
                "Une erreur est survenue lors de l'envoi du fichier."
            }
          })
          .finally(() => {
            this.uploadingPercent = null
          })
      },
      handleFileUpload(type) {
        if (type === 'images') {
          this.fileImages = this.$refs.fileImages.files[0]
        } else if (type === 'sounds') {
          this.fileSounds = this.$refs.fileSounds.files[0]
        } else if (type === 'videos') {
          this.fileVideos = this.$refs.fileVideos.files[0]
        } else if (type === 'games') {
          this.fileGames = this.$refs.fileGames.files[0]
        }
      },

      submitFile(type) {
        const token = localStorage.getItem('jwt')
        if (token) {
          let formData = new FormData()
          if (type === 'images') {
            formData.append('images', this.fileImages)
          } else if (type === 'sounds') {
            formData.append('sounds', this.fileSounds)
          } else if (type === 'videos') {
            formData.append('videos', this.fileVideos)
          } else if (type === 'games') {
            formData.append('games', this.fileGames)
          }

          axios
            .post('/medias/upload/' + type, formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: 'Bearer ' + token,
              },
            })
            .then(() => {
              console.log(type + ' file uploaded')
              this.$notify({
                type: 'success',
                title: 'Upload réalisé avec succès',
                text: 'Les ' + type + ' ont été mis à jour.',
              })
            })
            .catch((err) => {
              console.log('Failed to upload ' + type + ' file', err)
              this.$notify({
                type: 'error',
                title: "Echec de l'upload",
                text: err ? err : 'Erreur inconnue.',
              })
            })
        } else {
          this.$router.push('/login')
        }
      },

      // async downloadFile(type) {
      //   console.log('download ', type);
      //   const token = localStorage.getItem("jwt");
      //   let response;
      //   try {
      //     response = await axios.get("/medias/" + type, {
      //     headers: {
      //         "Content-Type": "multipart/form-data",
      //         'Authorization': 'Bearer ' + token
      //     },
      //     responseType: 'blob'
      //   });
      //   } catch (error) {
      //     this.$notify({
      //       type: "error",
      //       title: 'Téléchargement impossible',
      //       text: error ? error : 'Erreur inconnue.'
      //     });
      //   }

      // //   const filename = type + (type == 'games' ? '.txt' : '.zip');
      //   const filename = type + '.zip';
      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', filename);
      //   document.body.appendChild(link);
      //   link.click();
      // }
    },
  }
</script>
